import { createSelector } from 'reselect';
import { getInsurances } from './getInsurances';
import { type ReduxStateShared } from '~shared/types';

const getInsuranceID = (_: ReduxStateShared, insuranceID?: number) => insuranceID;

export const getInsuranceByID = createSelector([getInsurances, getInsuranceID], (insurances, insuranceID) => {
  return insurances.find(({ id }) => id === insuranceID);
});
